"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBadgeItemCount = void 0;
/**
 * Given a notification count, get the content for a notification badge.  Numbers greater
 * than 99 are "truncated" to 99+, for brevity.
 *
 * @param itemCount The number of notifications.
 */
var getBadgeItemCount = function (itemCount) {
    if (!itemCount) {
        return null;
    }
    return itemCount > 99 ? '99+' : "" + itemCount;
};
exports.getBadgeItemCount = getBadgeItemCount;
